module.exports = __webpack_public_path__ + "public/images/slider/potapov-circle.b2adb6decc42120a8a29cc155030ec28.png";